var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7821 14.3646L11.5287 19.6181C11.3322 19.8146 11.082 19.9129 10.7782 19.9129C10.4745 19.9129 10.2243 19.8146 10.0277 19.6181C9.83119 19.4215 9.73291 19.1713 9.73291 18.8676C9.73291 18.5638 9.83119 18.3136 10.0277 18.1171L15.2812 12.8637L10.0277 7.61026C9.83119 7.41371 9.73291 7.16354 9.73291 6.85977C9.73291 6.55601 9.83119 6.30584 10.0277 6.10929C10.2243 5.91273 10.4745 5.81445 10.7782 5.81445C11.082 5.81445 11.3322 5.91273 11.5287 6.10929L16.7821 11.3627L22.0355 6.10929C22.2321 5.91273 22.4823 5.81445 22.786 5.81445C23.0898 5.81445 23.34 5.91273 23.5365 6.10929C23.7331 6.30584 23.8313 6.55601 23.8313 6.85977C23.8313 7.16354 23.7331 7.41371 23.5365 7.61026L18.2831 12.8637L23.5365 18.1171C23.7331 18.3136 23.8313 18.5638 23.8313 18.8676C23.8313 19.1713 23.7331 19.4215 23.5365 19.6181C23.34 19.8146 23.0898 19.9129 22.786 19.9129C22.4823 19.9129 22.2321 19.8146 22.0355 19.6181L16.7821 14.3646Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.f36ba31d23112323b9207a9faea2c2e7.svg";
export { ForwardRef as ReactComponent };